
export const EMAIL_ENDPOINT_URL = "https://stage-api.coneeds.se/email";
